import React from 'react';

import Button from '@/components/ui/buttons/Button';
import Modal from '@/components/ui/modals/Modal';
import ForParentsAppInformation from '@/features/registration/components/ForParentsAppInformation';
import { type ModalInnerProps } from '@/hooks/common/useModal';
import useAppDownloadPopupDismissal from '@/hooks/mypage/useAppDownloadPopupDismissal';

import styles from './AppDownloadPopupModal.module.scss';

type Props = ModalInnerProps;

const AppDownloadPopupModal: React.FC<Props> = ({ isOpen, toggle }) => {
  const { dismiss } = useAppDownloadPopupDismissal({ enabled: false });

  const handleClose = () => {
    dismiss();
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      title="アプリ版リリースのお知らせ"
    >
      <div className={styles.AppDownloadPopupModal__Body}>
        <div className={styles.AppDownloadPopupModal__Description}>
          <p>
            <span className={styles.AppDownloadPopupModal__DescriptionBold}>
              スタディサプリ for PARENTS アプリ版
            </span>
            がリリースされました。
          </p>
          <p>
            <span className={styles.AppDownloadPopupModal__DescriptionPC}>
              アプリ版は学校からの新着連絡をプッシュ通知でリアルタイムに受け取れます。
            </span>
            <span className={styles.AppDownloadPopupModal__DescriptionSP}>
              アプリ版は新着メッセージを通知でお知らせ。より便利にお使いいただけます。
            </span>
          </p>
        </div>
        <div className={styles.AppDownloadPopupModal__AppInfo}>
          <ForParentsAppInformation />
        </div>
        <div className={styles.AppDownloadPopupModal__Footer}>
          <Button
            onClick={handleClose}
            size="m"
            color="outline"
            className={styles.AppDownloadPopupModal__CloseButton}
          >
            閉じる
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AppDownloadPopupModal;
